// @flow

import React from "react";
import SVG from "react-inlinesvg";
import Doc from "../../assets/icons/file/doc.svg";
import Button from "../Button";

import styles from "./DownloadBanner.scss";

type Props = {
  handleDownload: () => void,
  text: string,
  buttonLabel: string,
  buttonType?: string,
  buttonSize?: string
};

const DownloadBanner = ({
  handleDownload,
  text,
  buttonLabel,
  buttonType = "button",
  buttonSize = "medium"
}: Props) => {
  return (
    <div className={styles.wrapper}>
      <SVG className={styles.docIcon} src={Doc} />
      <span className={styles.requestText}>{text}</span>
      <Button
        type={buttonType}
        size={buttonSize}
        customStyles={styles.downloadButton}
        onClick={handleDownload}
      >
        {buttonLabel}
      </Button>
    </div>
  );
};

export default DownloadBanner;
